export type ComingSoonProduct = 'loja' | 'pagamentos'

export type ProductContextName = 'erp' | ComingSoonProduct

export const COMING_SOON_PRODUCT_PATHS: Record<ComingSoonProduct, string> = {
  loja: '/dashboard/products/loja',
  pagamentos: '/dashboard/products/pagamentos'
}
